import React, { useEffect } from "react";
import '../style/header.css';
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import api, { setApiInterceptors } from "../utils/api";

function Header() {
    const navigate = useNavigate();
    useEffect(() => {
        setApiInterceptors(navigate);
    }, [navigate]);

    const logout = async () => {
        Swal.fire({
            title: 'Are you sure you want to log out?',
            icon: 'question',
            iconColor: '#ab1717',
            confirmButtonText: 'Yes',
            confirmButtonColor: '#0E2F4F',
            showCancelButton: true,
            cancelButtonText: 'Cancel',
            preConfirm: async () => {
                try {
                    var result = await api.get('/logout')
                    if (result.status == 200) {
                        localStorage.removeItem('userToken');
                        if (result.data.userType == 'staff' || result.data.userType == 'admin') {
                            navigate('/mortgage/mga-staff-portal?logout=success');
                        } else {
                            navigate('/?logout=success');
                        }
                    }
                } catch (error) {
                    console.log("logout error ", error);
                }
            },
        })
    }

    const deleteUser = async () => {
        Swal.fire({
            title: 'Are you sure you want to delete your account?',
            icon: 'question',
            iconColor: '#ab1717',
            confirmButtonText: 'Yes',
            confirmButtonColor: '#0E2F4F',
            showCancelButton: true,
            cancelButtonText: 'Cancel',
            preConfirm: async () => {
                try {
                    const result = await api.delete('/delete-user');
                    if (result.status === 200) {
                        localStorage.removeItem('userToken');
                        const userType = result.data.userType;
                        if (userType === 'staff' || userType === 'admin') {
                            navigate('/mortgage/mga-staff-portal?logout=success');
                        } else {
                            navigate('/?delete=success');
                        }
                    }
                } catch (error) {
                    console.error("Delete user error", error);
                }
            },
        });
    }

    const handleLogoClick = () => {
        const userType = localStorage.getItem('userType');
        console.log('userType', userType);
        if (userType === 'main user' || userType === 'partner') {
            navigate('/mortgage_dashboard');
        } else {
            navigate('/mga-staff-portal/dashboard');
        }
    };

    return (
        <>
            <header className="headerStyle">
                <nav className="main-menu">
                    <div className="container">
                        <div className="logo-box">
                            <a href='' aria-label="logo image" onClick={handleLogoClick} ><img src="/0001.png" className="logo" alt="logo" /></a>
                            <div className="header-btns">
                                <div className="button-box">
                                    {localStorage.getItem('userToken') && (<button type="button" className="logout-btn" onClick={deleteUser}>Delete Account</button>)}
                                </div>
                                <div className="button-box">
                                    {localStorage.getItem('userToken') && (<button type="button" className="logout-btn" onClick={logout}>Log Out</button>)}
                                </div>
                            </div>
                        </div>
                    </div>
                </nav>
            </header>
        </>
    )
}

export default Header;